import { render, staticRenderFns } from "./Imc.vue?vue&type=template&id=b547c7ee&"
import script from "./Imc.vue?vue&type=script&lang=js&"
export * from "./Imc.vue?vue&type=script&lang=js&"
import style0 from "./Imc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports